import {
  ErrorValidationContext,
  defaultState,
} from 'modules/templateEditor/context/ErrorValidationContext';
import { useVariantTemplateValidationContext } from './ValidationContext';

export const LocaleSwitcherValidationContextProvider: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const { localesWithError } = useVariantTemplateValidationContext();
  return (
    <ErrorValidationContext.Provider
      value={{
        ...defaultState,
        /**
         * The locale switcher uses this to display the errors
         * in the locale option and shows the corresponding tooltip
         * So, we just populate this single attribute.
         */
        allContentErrors: localesWithError,
      }}
    >
      {children}
    </ErrorValidationContext.Provider>
  );
};
